import Stack from '@mui/material/Stack'
import OcrReaderLogo from 'assets/images/logoSl.svg'

export default function Error() {
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      textAlign="center"
      sx={{
        backgroundColor: 'grey.200',
        height: '100%',
      }}
    >
      <img style={{ margin: '16px auto' }} width="220px" src={OcrReaderLogo} alt="logo" />
      <p>Requested page Not found</p>
      <a href="/">Reload</a>
    </Stack>
  )
}
